(() => {
  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const policyHeadings = new Set([
    'Refund window', 'How to request a refund', 'Damaged, faulty, or incorrect items',
    'Approved refunds', 'Cancellations', 'Contact', 'Where we ship', 'Order processing',
    'Delivery time', 'Tracking your order', 'Import duties & customs', 'Lost or delayed shipments',
    'Damaged in transit', 'Overview', 'Eligibility', 'Products & descriptions', 'Pricing & payment',
    'Shipping, refunds & cancellations', 'Acceptable use', 'Intellectual property',
    'Third-party services', 'Disclaimers & liability', 'Governing law', 'Changes'
  ]);

  function makeHomepageH1Unique() {
    if (window.location.pathname.replace(/\/+$/, '') !== '') return;
    const hiddenStoreHeading = document.querySelector('#header-component > h1.visually-hidden');
    if (!hiddenStoreHeading) return;
    const replacement = document.createElement('span');
    [...hiddenStoreHeading.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    replacement.innerHTML = hiddenStoreHeading.innerHTML;
    hiddenStoreHeading.replaceWith(replacement);
  }

  function decodeHtml(html) {
    const element = document.createElement('div');
    element.innerHTML = html;
    return normalise(element.textContent);
  }

  function cleanPolicyText(body) {
    body.querySelectorAll('p, li').forEach((element) => {
      const text = normalise(element.textContent);
      if (text.includes('KINDSPUN sofa cover')) {
        element.textContent = element.textContent.replace(/KINDSPUN sofa cover/g, 'KINDSPUN Sofa Panel');
      }
      if (
        window.location.pathname.includes('/policies/contact-information') &&
        normalise(element.textContent) === 'KINDSPUN is operated from the Sultanate of Oman. We currently ship within the United States only.'
      ) {
        element.textContent = 'KINDSPUN is operated from the Sultanate of Oman.';
      }
    });
  }

  function polishPolicyMarkup() {
    const body = document.querySelector('.shopify-policy__body .rte') || document.querySelector('.shopify-policy__body');
    if (!body) return;
    cleanPolicyText(body);
    if (body.querySelector('h2')) return;

    const sourceParagraph = [...body.children].find((element) => element.tagName === 'P' && /<br\s*\/?\s*>/i.test(element.innerHTML));
    if (!sourceParagraph) return;

    let lines = sourceParagraph.innerHTML
      .split(/<br\s*\/?\s*>/i)
      .map(decodeHtml)
      .filter(Boolean)
      .map((line) => line.replace(/KINDSPUN sofa cover/g, 'KINDSPUN Sofa Panel'));
    if (lines.length < 3) return;

    if (/^\d+\.\s*(Shipping Policy|Refund\s*&\s*Return Policy|Terms of Service)$/i.test(lines[0])) {
      lines = lines.slice(1);
    }

    const fragment = document.createDocumentFragment();
    let paragraphLines = [];
    const flushParagraph = () => {
      if (!paragraphLines.length) return;
      const paragraph = document.createElement('p');
      paragraph.textContent = paragraphLines.join(' ');
      fragment.appendChild(paragraph);
      paragraphLines = [];
    };

    lines.forEach((line) => {
      if (/^Last updated:/i.test(line)) {
        flushParagraph();
        const updated = document.createElement('p');
        updated.className = 'ks-policy-updated';
        updated.textContent = line;
        fragment.appendChild(updated);
        return;
      }
      if (policyHeadings.has(line)) {
        flushParagraph();
        const heading = document.createElement('h2');
        heading.textContent = line;
        fragment.appendChild(heading);
        return;
      }
      paragraphLines.push(line);
    });
    flushParagraph();
    sourceParagraph.replaceWith(fragment);
  }

  const run = () => {
    makeHomepageH1Unique();
    polishPolicyMarkup();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
